<p-accordion [multiple]="true">
  <p-accordionTab *ngFor="let worker of groupedWorkers" [(selected)]="worker.isOpen">    
    <ng-template pTemplate="header">      
      <div class="flex justify-between items-center w-full align-items-center">
        Operario: {{ worker.workerName }}      
        <div class="flex gap-2 ml-auto">
          <p-tag severity="secondary" value="Total coste: {{(getWorkerJobsTotal(worker).subtotalWorker ) | currency: 'EUR'}}" 
            class="fixed-tag"/>      
          <p-tag severity="secondary" value="Total compañía: {{getWorkerJobsTotal(worker).subtotalCompany | currency: 'EUR'}}" 
            class="fixed-tag"/> 
            
          <p-tag
          [severity]="getProfitPercent(worker) > (case.contract?.profitDesiredPercent ?? 0) ? 'success' : getProfitPercent(worker) > (case.contract?.profitMinPercent ?? 0) ? 'warn' : 'danger'"
          value="{{getProfitPercent(worker) | number:'1.2-2'}}% beneficio" 
            class="fixed-tag"/>    
          <p-tag 
          [severity]="getProfitPercent(worker) > (case.contract?.profitDesiredPercent ?? 0) ? 'success' : getProfitPercent(worker) > (case.contract?.profitMinPercent ?? 0) ? 'warn' : 'danger'"
          value="{{getProfit(worker) | currency: 'EUR'}} beneficio" 
            class="fixed-tag"/>
        </div>
      </div>
    </ng-template>
    <p-card styleClass="p-card-content-no-padding p-card-body-pt-0">
      <ng-template pTemplate="header">
        <div class="p-card-title flex gap-2">
          <div class="flex-grow-1">Trabajos a la compañia</div>          
        </div>
      </ng-template>
      <div>        
        <p-table [value]="worker.services">

          <ng-template pTemplate="header">
            <tr>
              <th width="80">Fecha</th>
              <th>Baremo</th>
              <th>Revisado</th>
              <th>Facturable</th>
              <th>Destinatario</th>
              <th>Factura</th>
              <th style="text-align: right;">Cantidad</th>
              <th style="text-align: right;">Precio</th>
              <th style="text-align: right;">SubTotal</th>
              <th style="text-align: right;">Impuestos</th>
              <th style="text-align: right;">Total</th>
              <th width="120"></th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-service>
            <tr class="bg-gray-200 font-bold">
              <td colspan="2">
                <div class="flex gap-2 align-items-center">
                  <p-button size="small" label="" icon="pi pi-wrench" (click)="openServiceOp($event, service)"/>
                  Cita del {{ service.date | date: 'dd/MM/yyyy HH:mm' }}
                  <p-tag severity="success" value="Validado" *ngIf="service.isValidated" />
                  <p-tag severity="warn" value="Sin validar"  *ngIf="!service.isValidated" />
                  <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox [disabled]="getFilteredJobs(service, worker, true).length>0" 
                    styleClass="ml-4"  [(ngModel)]="service.companyJobsNoRequired" (onChange)="toogleCompanyJobsNoRequired($event, service)" [binary]="true"></p-checkbox>No procede</label>
                </div>
                <div *ngIf="service.caseNotificationNumberId"><small>Nº servicio: {{service.caseNotificationNumber?.code}} - {{service.caseNotificationNumber?.date | date: 'dd/MM/yyyy'}} - {{service.caseNotificationNumber?.capabilityDescription}}</small></div>
              </td>
              <td>
                <p-checkbox *ngIf="!service.companyJobsNoRequired; else companyReviewedOff" [ngModel]="isServiceJobsAllReviewed(service, true)" (onChange)="toggleReviewed($event, service, true)" [binary]="true"></p-checkbox>
                <ng-template #companyReviewedOff><p-checkbox [disabled]="true" [ngModel]="false" [binary]="true"></p-checkbox></ng-template>
              </td>
              <td>
                <p-checkbox *ngIf="!service.companyJobsNoRequired; else companyBillableOff" [ngModel]="isServiceJobsAllBillable(service, true)" (onChange)="toggleBillable($event, service, true)" [binary]="true"></p-checkbox>
                <ng-template #companyBillableOff><p-checkbox [disabled]="true" [ngModel]="false" [binary]="true"></p-checkbox></ng-template>
              </td>
              <td colspan="8">
                <div class="flex gap-2 justify-content-end">
                  <p-button size="small" label="Validar" icon="pi pi-check" (click)="caseServiceValidated(service, worker)" *ngIf="allowWrite&&!service.isValidated"/>
                  <p-button [disabled]="service.companyJobsNoRequired" size="small" label="Generar trabajos IA" icon="pi pi-microchip-ai" (click)="requestAIGenerate(service)" *ngIf="allowWrite"/>
                  <p-button [disabled]="service.companyJobsNoRequired" size="small" label="Importar plantilla" icon="pi pi-plus" (click)="importRateTemplate('COMPANY', service.id)" *ngIf="allowWrite"/>
                  <p-button [disabled]="service.companyJobsNoRequired" *ngIf="service.hasTransactions==0&&allowWrite" size="small" label="Importar presupuesto" icon="pi pi-plus" (click)="importTransactionLines('COMPANY', service.id, worker.workerId)" />
                  <p-button [disabled]="service.companyJobsNoRequired" *ngIf="service.hasTransactions>0&&allowWrite" badgeClass="bullet" badge="{{service.hasTransactions}}"  label="Importar presupuesto" icon="pi pi-plus" (click)="importTransactionLines('COMPANY', service.id, worker.workerId)"/>
                  <p-button [disabled]="service.companyJobsNoRequired" size="small" label="Añadir trabajo" icon="pi pi-plus" (click)="editJob('COMPANY', null, service, worker.workerId)" *ngIf="allowWrite" />
                </div>
              </td>
            </tr>
            <tr *ngFor="let companyJob of getFilteredJobs(service, worker, true)" (dblclick)="editJob('COMPANY', companyJob, service, worker.workerId)">              
              <td [style.borderLeft]="getBorderStyle(companyJob)">{{ companyJob.date | date: 'dd/MM/yyyy' }}</td>
              <td>
                <div>{{ companyJob.code }} - {{ companyJob.rateLineDescription }}</div>
                <div *ngIf="companyJob.description">{{ companyJob.description }}</div>
              </td>
              <td>
                <i class="pi" [ngClass]="{
                              'text-green-500 pi-check-circle': companyJob.isReview,
                              'text-red-500 pi-times-circle': !companyJob.isReview
                          }"></i>
              </td>
              <td>
                <i class="pi" [ngClass]="{
                              'text-green-500 pi-check-circle': companyJob.isBillable,
                              'text-red-500 pi-times-circle': !companyJob.isBillable
                          }"></i>
              </td>
              <td>
                {{ companyJob.target == 'Client' ? 'Asegurado' : companyJob.target == 'Company' ? 'Compañía' : companyJob.target == 'ThirdParty' ? 'Implicado' : '' }}
              </td>
              <td>
                <a *ngIf="companyJob.transactionId"
                  (click)="goToTransaction(companyJob.transactionId, companyJob.transaction?.transactionType?.code)">
                  {{ companyJob.transaction?.code + ' - ' + (companyJob.transaction?.date | date:'dd/MM/yy') }}
                </a><br>
                <span *ngIf="companyJob.transactionId" class="p-tag" [style.backgroundColor]="companyJob.transaction?.transactionState?.backgroundColor" [style.foregroundColor]="companyJob.transaction?.transactionState?.foregroundColor">
                  <span class="p-tag-label">{{companyJob.transaction?.transactionState?.name}}</span>
                </span>
                <br>
                <a *ngIf="companyJob.transactionId && companyJob.transaction?.relatedTransactionId"
                  (click)="goToTransaction(companyJob.transactionId, companyJob.transaction?.relatedTransaction?.code)">
                  {{ companyJob.transaction?.relatedTransaction?.code + ' - ' + (companyJob.transaction?.relatedTransaction?.date | date:'dd/MM/yy') }}
                </a><br>
                <span *ngIf="companyJob.transactionId && companyJob.transaction?.relatedTransactionId" class="p-tag" [style.backgroundColor]="companyJob.transaction?.relatedTransaction?.transactionState?.backgroundColor" [style.foregroundColor]="companyJob.transaction?.relatedTransaction?.transactionState?.foregroundColor">
                  <span class="p-tag-label">{{companyJob.transaction?.relatedTransaction?.transactionState?.name}}</span>
                </span>
              </td>
              <td style="text-align: right;">{{ companyJob.quantity }}</td>
              <td style="text-align: right;">
                {{ companyJob.unitPrice | currency: 'EUR' }} 
                <span *ngIf="companyJob.jobCompanyDiscountPercent">({{ companyJob.jobCompanyDiscountPercent }}%)</span>
                <small *ngIf="companyJob.jobGuardCompanyIncrementPercent"><br>(Guardia: {{ companyJob.jobGuardCompanyIncrementPercent }}%)</small>
              </td>
              <td style="text-align: right;">{{ companyJob.subtotal | currency: 'EUR' }}</td>
              <td style="text-align: right;">
                {{ '(' + (companyJob.taxPercent != null ? companyJob.taxPercent : 0) + '%) ' }}
                {{ companyJob.taxAmount | currency: 'EUR' }}
              </td>
              <td style="text-align: right;">
                <div class="flex gap-2 align-items-center justify-content-end" [class.text-warning]="companyJob.chargedByWorker">
                  {{ companyJob.total | currency: 'EUR' }}
                  <span *ngIf="companyJob.chargedByWorker" pTooltip="Cobrado por el operario"><i class="pi pi-user"></i></span>
                </div>
              </td>
              <td>
                <div class="flex gap-2 justify-content-end" style="width: 100%;">
                  <p-button *ngIf="allowDelete && companyJob.transactionId == null && !companyJob.isBillable && companyJob.workerBillableItemLineId == null" (click)="deleteJob(companyJob)"
                    [rounded]="true" [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                  <p-button *ngIf="allowWrite" (click)="editJob('COMPANY', companyJob, service, worker.workerId)" [rounded]="true"
                                  [text]="false"><i class="pi pi-pencil"></i></p-button>
                </div>
              </td>
            </tr>
            <tr *ngIf="getFilteredJobs(service, worker, true).length ==0">
              <td [attr.colspan]="12">
                No se han encontrado trabajos registrados
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="footer">
            <tr>
              <td colspan="8" class="text-right">Base Imponible</td>
              <td style="text-align: right;">{{getWorkerJobsTotal(worker).subtotalCompany | currency: 'EUR'}}</td>
              <td class="text-right">Total</td>
              <td style="text-align: right;">{{getWorkerJobsTotal(worker).totalCompany | currency: 'EUR'}}</td>
              <td colspan="1"></td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="12">No se han encontrado trabajos registrados</td>
            </tr>
          </ng-template>
        </p-table>


      </div>

    </p-card>

    <div class="mt-4">
      <p-card styleClass="p-card-content-no-padding p-card-body-pt-0">
        <ng-template pTemplate="header">
          <div class="p-card-title flex gap-2">
            <div class="flex-grow-1">Trabajos al operario</div>            
          </div>
        </ng-template>
        <div>
          <div *ngIf="worker?.hasSubmitInvoice" class="mb-4">
            <p-messages severity="warn">
              <ng-template pTemplate>
                Este operario debe presentar factura, no olvides adjuntarla.
              </ng-template>
            </p-messages>
            <p-table styleClass="mt-4" [value]="worker.services">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th pSortableColumn="code">Código <p-sortIcon field="code"></p-sortIcon></th>
                  <th pSortableColumn="date">Fecha <p-sortIcon field="date"></p-sortIcon></th>
                  <th pSortableColumn="transactionState.name">Estado <p-sortIcon
                      field="transactionState.name"></p-sortIcon></th>
                  <th style="text-align: right;" pSortableColumn="subtotal">Neto <p-sortIcon field="subtotal"></p-sortIcon>
                  </th>
                  <th width="200"></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-service>
                <tr class="bg-gray-200 font-bold">
                  <td colspan="3" style="text-align: left;">
                    Cita del {{ service.date | date: 'dd/MM/yyyy HH:mm' }}                  
                  </td>
                  <td colspan="2">
                    <div class="flex gap-2 justify-content-end">  
                      <p-button size="small" label="Añadir factura" icon="pi pi-plus" (click)="editTransaction(null, service.id,worker.workerId)"
                        *ngIf="allowWrite && worker?.hasSubmitInvoice"/>
                    </div>
                  </td>
                </tr>
                <tr *ngFor="let transactionLine of getFilteredTransactionLines(service, worker)" (dblclick)="editTransaction(transactionLine.transactionId, service.id, worker.workerId)">                                
                  <td>{{transactionLine.transaction?.code}}</td>
                  <td>{{transactionLine.transaction?.date | date:'dd/MM/yy'}}</td>
                  <td>{{transactionLine.transaction?.transactionState?.name}}</td>
                  <td style="text-align: right;">{{transactionLine.transaction?.subtotal | currency:'EUR'}}</td>
                  <td>
                    <div class="flex gap-2 justify-content-end">
                      <p-button *ngIf="allowWrite" (click)="downloadFile(transactionLine.transaction?.fileId)"
                        [rounded]="true" [text]="false"><i class="pi pi-download"></i></p-button>
                      <p-button *ngIf="allowDelete" (click)="deleteTransaction(transactionLine)" [rounded]="true"
                        [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                      <p-button *ngIf="allowWrite" (click)="editTransaction(transactionLine.transactionId, service.id, worker.workerId)" [rounded]="true"
                                      [text]="false"><i class="pi pi-pencil"></i></p-button>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="footer">
                <tr>                  
                  <td colspan="4" style="text-align: right;">Total: {{getWorkerTransactionsTotal(worker) | currency: 'EUR'}}</td>
                  <td colspan="1"></td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="6">
                    No se ha encontrado transacciones
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>

          <div>
            <p-messages severity="warn"  *ngIf="worker?.hasSubmitInvoice">
              <ng-template pTemplate>
                Este operario debe presentar factura, los baremos que indique a continuación no se liquidarán mediante facturación.
              </ng-template>
            </p-messages>
            <p-table [value]="worker.services">
              <ng-template pTemplate="header">
                <tr>
                  <th>Fecha</th>
                  <th>Baremo</th>
                  <th>Revisado</th>
                  <th>Facturable</th>
                  <th>Factura</th>
                  <th style="text-align: right;">Cantidad</th>
                  <th style="text-align: right;">Precio</th>
                  <th style="text-align: right;">SubTotal</th>
                  <th style="text-align: right;">Impuestos</th>
                  <th style="text-align: right;">Total</th>
                  <th width="120"></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-service>
                <tr class="bg-gray-200 font-bold">
                  <td colspan="2">
                    <div class="flex gap-2 align-items-center">
                      <p-button size="small" label="" icon="pi pi-wrench" (click)="openServiceOp($event, service)"/>
                      Cita del {{ service.date | date: 'dd/MM/yyyy HH:mm' }}
                      <p-tag severity="success" value="Validado" *ngIf="service.isValidated" />
                      <p-tag severity="warn" value="Sin validar"  *ngIf="!service.isValidated" />
                      <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox [disabled]="getFilteredJobs(service, worker, false).length>0" styleClass="ml-4" [(ngModel)]="service.workerJobsNoRequired" (onChange)="toogleWorkerJobsNoRequired($event, service)" [binary]="true"></p-checkbox>No procede</label>
                    </div>
                  </td>
                  <td>
                    <p-checkbox *ngIf="!service.workerJobsNoRequired; else workerReviewedOff" [ngModel]="isServiceJobsAllReviewed(service, false)" (onChange)="toggleReviewed($event, service, false)" [binary]="true"></p-checkbox>
                    <ng-template #workerReviewedOff><p-checkbox [disabled]="true" [ngModel]="false" [binary]="true"></p-checkbox></ng-template>
                  </td>
                  <td>
                    <p-checkbox *ngIf="!service.workerJobsNoRequired; else workerBillableOff" [ngModel]="isServiceJobsAllBillable(service, false)" (onChange)="toggleBillable($event, service, false)" [binary]="true"></p-checkbox>
                    <ng-template #workerBillableOff><p-checkbox [disabled]="true" [ngModel]="false" [binary]="true"></p-checkbox></ng-template>
                  </td>
                  <td colspan="7">
                    <div class="flex gap-2 justify-content-end">
                      <p-button size="small" label="Validar" icon="pi pi-check" (click)="caseServiceValidated(service, worker)" *ngIf="allowWrite&&!service.isValidated"/>
                      <p-button [disabled]="service.workerJobsNoRequired" size="small" label="Generar trabajos IA" icon="pi pi-microchip-ai" (click)="requestAIGenerate(service)" *ngIf="allowWrite"/>
                      <p-button [disabled]="service.workerJobsNoRequired" size="small" label="Importar plantilla" icon="pi pi-plus" (click)="importRateTemplate('WORKER', service.id)" /> 
                      <p-button [disabled]="service.workerJobsNoRequired" size="small" *ngIf="service.hasTransactions==0" label="Importar presupuesto" icon="pi pi-plus" (click)="importTransactionLines('WORKER', service.id, worker.workerId)" />           
                      <p-button [disabled]="service.workerJobsNoRequired" *ngIf="service.hasTransactions>0" badgeClass="bullet" badge="{{service.hasTransactions}}"  label="Importar presupuesto" icon="pi pi-plus" (click)="importTransactionLines('WORKER', service.id, worker.workerId)"/>
                      <p-button [disabled]="service.workerJobsNoRequired" size="small" label="Añadir trabajo" icon="pi pi-plus" (click)="editJob('WORKER', null, service,worker.workerId)" *ngIf="allowWrite" />
                    </div>
                  </td>
                </tr>              
                <tr *ngFor="let workerJob of getFilteredJobs(service, worker, false)" (dblclick)="editJob('WORKER', workerJob, service,worker.workerId)">                
                  <td [style.borderLeft]="getBorderStyle(workerJob)">
                    <i class="pi pi-microchip-ai" *ngIf="workerJob.isIAGenerate"></i>
                    {{workerJob.date | date: 'dd/MM/yyyy HH:mm'}}
                  </td>
                  <td>
                    {{workerJob.code}} - {{workerJob.rateLineDescription}}
                    <div *ngIf="workerJob.description">{{workerJob.description}}</div>
                  </td>
                  <td>
                    <i class="pi"
                      [ngClass]="{ 'text-green-500 pi-check-circle': workerJob.isReview, 'text-red-500 pi-times-circle': !workerJob.isReview}"></i>
                  </td>
                  <td>
                    <i class="pi"
                      [ngClass]="{ 'text-green-500 pi-check-circle': workerJob.isBillable, 'text-red-500 pi-times-circle': !workerJob.isBillable}"></i>
                  </td>
                  <td> 
                    <a *ngIf="workerJob.transactionId"
                      (click)="goToTransaction(workerJob.transactionId, workerJob.transaction?.transactionType?.code)">
                      {{workerJob.transactionId!=null? (workerJob.transaction?.code + ' - ' + (workerJob.transaction?.date | date:'dd/MM/yy')) :''}}
                    </a><br>
                    <span *ngIf="workerJob.transactionId" class="p-tag" [style.backgroundColor]="workerJob.transaction?.transactionState?.backgroundColor" [style.foregroundColor]="workerJob.transaction?.transactionState?.foregroundColor">
                      <span class="p-tag-label">{{workerJob.transaction?.transactionState?.name}}</span>
                    </span>

                  </td>
                  <td style="text-align: right;">
                    {{workerJob.quantity}}
                  </td>
                  <td style="text-align: right;">
                    {{workerJob.unitPrice | currency: 'EUR' }}
                  </td>
                  <td style="text-align: right;">
                    {{workerJob.subtotal | currency: 'EUR' }}
                  </td>
                  <td style="text-align: right;">
                    {{'('+(workerJob.taxPercent!=null?workerJob.taxPercent:0)+'%) '}}{{workerJob.taxAmount | currency: 'EUR' }}
                  </td>
                  
                  <td style="text-align: right;">
                    {{workerJob.total}}
                  </td>
                  <td>
                    <div class="flex gap-2 justify-content-end" style="width: 100%;">
                      <p-button *ngIf="allowDelete && workerJob.transactionId == null && !workerJob.isBillable && workerJob.workerBillableItemLineId == null" (click)="deleteJob(workerJob)"
                        [rounded]="true" [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                      <p-button *ngIf="allowWrite" (click)="editJob('WORKER', workerJob, service,worker.workerId)" [rounded]="true"
                                    [text]="false"><i class="pi pi-pencil"></i></p-button>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="getFilteredJobs(service, worker, false).length ==0">
                  <td [attr.colspan]="12">
                    No se han encontrado trabajos registrados
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="footer">
                <tr>
                <td colspan="7" class="text-right">Base Imponible</td>
                <td style="text-align: right;">{{getWorkerJobsTotal(worker).subtotalWorker | currency: 'EUR'}}</td>
                <td class="text-right">Total</td>
                  <td style="text-align: right;">{{getWorkerJobsTotal(worker).totalWorker | currency: 'EUR'}}</td>
                  <td colspan="1"></td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="12">
                    No se han encontrado trabajos registrados
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>

      </p-card>      
    </div>
  </p-accordionTab>  


<p-accordionTab *ngFor="let provider of groupedProviders" [(selected)]="provider.isOpen">    
    <ng-template pTemplate="header">      
      <div class="flex justify-between items-center w-full align-items-center">
        Proveedor: {{ provider.name }} <span style="color:#d32f2f;" *ngIf="provider.deleted"> (borrado)</span>  
        <div class="flex gap-2 ml-auto">
          <p-tag severity="secondary" value="Total material: {{(getProviderJobsTotal(provider).subtotalProvider ) | currency: 'EUR'}}" 
            class="fixed-tag"/>      
          <p-tag severity="secondary" value="Total compañía: {{getProviderJobsTotal(provider).subtotalCompany | currency: 'EUR'}}" 
            class="fixed-tag"/>    
          <p-tag
          [severity]="getProfitProvidersPercent(provider) > (case.contract?.profitDesiredPercent ?? 0) ? 'success' : getProfitProvidersPercent(provider) > (case.contract?.profitMinPercent ?? 0) ? 'warn' : 'danger'"
          value="{{getProfitProvidersPercent(provider) | number:'1.2-2'}}% beneficio" 
            class="fixed-tag"/>    
          <p-tag 
          [severity]="getProfitProvidersPercent(provider) > (case.contract?.profitDesiredPercent ?? 0) ? 'success' : getProfitProvidersPercent(provider) > (case.contract?.profitMinPercent ?? 0) ? 'warn' : 'danger'"
          value="{{getProfitProviders(provider) | currency: 'EUR'}} beneficio" 
            class="fixed-tag"/>
        </div>
      </div>
    </ng-template>
    <p-card styleClass="p-card-content-no-padding p-card-body-pt-0">
      <ng-template pTemplate="header">
        <div class="p-card-title flex gap-2">
          <div class="flex-grow-1">
            Trabajos a la compañia
              <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox [disabled]="provider.companyJobs.length>0" 
                    styleClass="ml-4" (onChange)="toogleProviderCompanyJobsNoRequired($event, provider)"  [(ngModel)]="provider.companyJobsNoRequired" [binary]="true"></p-checkbox>No procede</label>
          </div>   
          <div class="flex gap-2 justify-content-end">
              <p-button [disabled]="provider.companyJobsNoRequired" *ngIf="!provider.hasTransaction&&allowWrite" size="small"  label="Importar solicitud compra" icon="pi pi-plus" (click)="importTransactionLines('COMPANY', null, null, provider.id)" />
              <p-button [disabled]="provider.companyJobsNoRequired" *ngIf="provider.hasTransaction&&allowWrite" badgeClass="bullet" badge="-" size="small"  label="Importar solicitud compra" icon="pi pi-plus" (click)="importTransactionLines('COMPANY', null, null, provider.id)" />
              <p-button [disabled]="provider.companyJobsNoRequired" size="small" label="Añadir trabajo" icon="pi pi-plus" (click)="editJob('COMPANY', null, null, provider.workerId, provider.id)" *ngIf="allowWrite" />
            </div>        
        </div>
      </ng-template>
      <div>   
          
        <p-table [value]="provider.companyJobs">

          <ng-template pTemplate="header">
            <tr>
              <th width="80">Fecha</th>
              <th>Descripción</th>
              <th>Revisado</th>
              <th>Facturable</th>
              <th>Destinatario</th>
              <th>Factura</th>
              <th style="text-align: right;">Cantidad</th>
              <th style="text-align: right;">Precio</th>
              <th style="text-align: right;">SubTotal</th>
              <th style="text-align: right;">Impuestos</th>
              <th style="text-align: right;">Total</th>
              <th width="120"></th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-job>
            <tr>              
              <td>{{ job.date | date: 'dd/MM/yyyy' }}</td>
              <td>
                <div *ngIf="job.rateLine">{{ job.rateLine?.code }} - {{ job.rateLine?.description }}</div>
                <div *ngIf="job.rateLine==null&&job.rateLineCode">{{ job.rateLineCode }} - {{ job.rateLineDescription }}</div>
                <div *ngIf="job.description">{{ job.description }}</div>
              </td>
              <td>
                <i class="pi" [ngClass]="{
                              'text-green-500 pi-check-circle': job.isReview,
                              'text-red-500 pi-times-circle': !job.isReview
                          }"></i>
              </td>
              <td>
                <i class="pi" [ngClass]="{
                              'text-green-500 pi-check-circle': job.isBillable,
                              'text-red-500 pi-times-circle': !job.isBillable
                          }"></i>
              </td>
              <td>
                {{ job.target == 'Client' ? 'Asegurado' : job.target == 'Company' ? 'Compañía' : '' }}
              </td>
              <td>
                <a *ngIf="job.transactionId"
                  (click)="goToTransaction(job.transactionId, job.transaction?.transactionType?.code)">
                  {{ job.transaction?.code + ' - ' + (job.transaction?.date | date:'dd/MM/yy') }}
                </a><br>
                <span *ngIf="job.transactionId" class="p-tag" [style.backgroundColor]="job.transaction?.transactionState?.backgroundColor" [style.foregroundColor]="job.transaction?.transactionState?.foregroundColor">
                  <span class="p-tag-label">{{job.transaction?.transactionState?.name}}</span>
                </span>
                <br>
                <a *ngIf="job.transactionId && job.transaction?.relatedTransactionId"
                  (click)="goToTransaction(job.transactionId, job.transaction?.relatedTransaction?.code)">
                  {{ job.transaction?.relatedTransaction?.code + ' - ' + (job.transaction?.relatedTransaction?.date | date:'dd/MM/yy') }}
                </a><br>
                <span *ngIf="job.transactionId && job.transaction?.relatedTransactionId" class="p-tag" [style.backgroundColor]="job.transaction?.relatedTransaction?.transactionState?.backgroundColor" [style.foregroundColor]="job.transaction?.relatedTransaction?.transactionState?.foregroundColor">
                  <span class="p-tag-label">{{job.transaction?.relatedTransaction?.transactionState?.name}}</span>
                </span>
                
              </td>
              <td style="text-align: right;">{{ job.quantity }}</td>
              <td style="text-align: right;">
                {{ job.unitPrice | currency: 'EUR' }} 
                <span *ngIf="job.jobCompanyDiscountPercent">({{ job.jobCompanyDiscountPercent }}%)</span>
                <small *ngIf="job.jobGuardCompanyIncrementPercent"><br>(Guardia: {{ job.jobGuardCompanyIncrementPercent }}%)</small>
              </td>
              <td style="text-align: right;">{{job.subtotal | currency: 'EUR' }}</td>
              <td style="text-align: right;">
                {{ '(' + (job.taxPercent != null ? job.taxPercent : 0) + '%) ' }}
                {{ job.taxAmount | currency: 'EUR' }}
              </td>
              <td style="text-align: right;">{{ job.total | currency: 'EUR' }}</td>
              <td>
                <div class="flex gap-2 justify-content-end" style="width: 100%;">
                  <p-button *ngIf="allowDelete && job.transactionId == null && !job.isBillable && job.workerBillableItemLineId == null" (click)="deleteJob(job)"
                    [rounded]="true" [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                  <p-button *ngIf="allowWrite" (click)="editJob('COMPANY', job, null, job.workerId, job.providerId)" [rounded]="true"
                                  [text]="false"><i class="pi pi-pencil"></i></p-button>
                </div>
              </td>
            </tr>
            <tr *ngIf="getFilteredJobsProviders(provider, true).length ==0">
              <td [attr.colspan]="11">
                No se han encontrado trabajos registrados
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="footer">
            <tr>
              <td colspan="8" class="text-right">Base Imponible</td>
              <td style="text-align: right;">{{getProviderJobsTotal(provider).subtotalCompany | currency: 'EUR'}}</td>
              <td class="text-right">Total</td>
              <td style="text-align: right;">{{getProviderJobsTotal(provider).totalCompany | currency: 'EUR'}}</td>
              <td colspan="1"></td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="12">No se han encontrado trabajos registrados</td>
            </tr>
          </ng-template>
        </p-table>


      </div>

    </p-card>

    <div class="mt-4">
      <p-card styleClass="p-card-content-no-padding p-card-body-pt-0">
        <ng-template pTemplate="header">
          <div class="p-card-title flex gap-2">
            <div class="flex-grow-1">
              Trabajos al proveedor               
            </div>   
            <div class="flex gap-2 justify-content-end">
                <p-button *ngIf="!provider.hasTransaction&&allowWrite" size="small" label="Importar solicitud compra" icon="pi pi-plus" (click)="importTransactionLines('WORKER', null, null, provider.id)"/>
                <p-button *ngIf="provider.hasTransaction&&allowWrite" badgeClass="bullet" badge="-" size="small" label="Importar solicitud compra" icon="pi pi-plus" (click)="importTransactionLines('WORKER', null, null, provider.id)" />
              
                  <p-button size="small" label="Añadir trabajo" icon="pi pi-plus" (click)="editJob('PROVIDER', null, null, null, provider.id)" *ngIf="allowWrite" />
                </div>           
          </div>
        </ng-template>
          <div>
            <p-table [value]="provider.providerJobs">
              <ng-template pTemplate="header">
                <tr>
                  <th>Fecha</th>
                  <th>Descripción</th>
                  <th>Revisado</th>
                  <th>Facturable</th>
                  <th>Factura</th>
                  <th style="text-align: right;">Cantidad</th>
                  <th style="text-align: right;">Precio</th>
                  <th style="text-align: right;">SubTotal</th>
                  <th style="text-align: right;">Impuestos</th>
                  <th style="text-align: right;">Total</th>
                  <th width="120"></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-providerJob>
             
                <tr>                
                  <td [style.borderLeft]="getBorderStyle(providerJob)">
                    <i class="pi pi-microchip-ai" *ngIf="providerJob.isIAGenerate"></i>
                    {{providerJob.date | date: 'dd/MM/YY HH:mm'}}
                  </td>
                  <td>
                    {{providerJob.rateLine?.code}} - {{providerJob.rateLine?.description}}

                    <div *ngIf="providerJob.rateLine==null&&providerJob.rateLineCode">{{ providerJob.rateLineCode }} - {{ providerJob.rateLineDescription }}</div>
                    <div *ngIf="providerJob.description">{{providerJob.description}}</div>
                  </td>
                  <td>
                    <i class="pi"
                      [ngClass]="{ 'text-green-500 pi-check-circle': providerJob.isReview, 'text-red-500 pi-times-circle': !providerJob.isReview}"></i>
                  </td>
                  <td>
                    <i class="pi"
                      [ngClass]="{ 'text-green-500 pi-check-circle': providerJob.isBillable, 'text-red-500 pi-times-circle': !providerJob.isBillable}"></i>
                  </td>
                  <td> 
                    <!--<a *ngIf="providerJob.transactionId"
                      (click)="goToTransaction(providerJob.transactionId, providerJob.transaction?.transactionType?.code)">
                      {{providerJob.transactionId!=null? (providerJob.transaction?.code + ' - ' + (providerJob.transaction?.date | date:'dd/MM/yy')) :''}}
                    </a><br>
                    <span *ngIf="providerJob.transactionId" class="p-tag" [style.backgroundColor]="providerJob.transaction?.transactionState?.backgroundColor" [style.foregroundColor]="providerJob.transaction?.transactionState?.foregroundColor">
                      <span class="p-tag-label">{{providerJob.transaction?.transactionState?.name}}</span>
                    </span> -->
                    
                      {{providerJob.purchaseTransaction?.relatedInvoiceCode}}
                      <br *ngIf="providerJob.purchaseTransactionId">
                      <span *ngIf="providerJob.purchaseTransactionId" class="p-tag" [style.backgroundColor]="providerJob.purchaseTransaction?.transactionState?.backgroundColor" [style.foregroundColor]="providerJob.purchaseTransaction?.transactionState?.foregroundColor">
                        <span class="p-tag-label">{{providerJob.purchaseTransaction?.transactionState?.name}}</span>
                      </span>
                  </td>
                  <td style="text-align: right;">
                    {{providerJob.quantity}}
                  </td>
                  <td style="text-align: right;">
                    {{providerJob.unitPrice}}
                  </td>
                  <td style="text-align: right;">{{providerJob.subtotal | currency: 'EUR' }}</td>
                  <td style="text-align: right;">
                    {{'('+(providerJob.taxPercent!=null?providerJob.taxPercent:0)+'%) '}}{{providerJob.taxAmount |
                    currency: 'EUR' }}
                  </td>
                  <td style="text-align: right;">
                    {{providerJob.total}}
                  </td>
                  <td>
                    <div class="flex gap-2 justify-content-end" style="width: 100%;">
                      <p-button *ngIf="allowDelete && providerJob.transactionId == null && !providerJob.isBillable && providerJob.workerBillableItemLineId == null" (click)="deleteJob(providerJob)"
                        [rounded]="true" [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                      <p-button *ngIf="allowWrite" (click)="editJob('WORKER', providerJob, null,providerJob.workerId, providerJob.providerId)" [rounded]="true"
                                    [text]="false"><i class="pi pi-pencil"></i></p-button>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="getFilteredJobsProviders(provider, false).length ==0">
                  <td [attr.colspan]="10">
                    No se han encontrado trabajos registrados
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="footer">
                <tr>
                <td colspan="7" class="text-right">Base Imponible</td>
                <td style="text-align: right;">{{getProviderJobsTotal(provider).subtotalProvider | currency: 'EUR'}}</td>
                <td class="text-right">Total</td>
                  <td style="text-align: right;">{{getProviderJobsTotal(provider).totalProvider | currency: 'EUR'}}</td>
                  <td colspan="1"></td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="11">
                    No se han encontrado trabajos registrados
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>

      </p-card>      
    </div>
  </p-accordionTab>  




  
<p-accordionTab *ngFor="let other of others" [(selected)]="other.isOpen">    
    <ng-template pTemplate="header">      
      <div class="flex justify-between items-center w-full align-items-center">
        {{ other.name }}      
        <div class="flex gap-2 ml-auto">          
          <p-tag severity="secondary" value="Total compañía: {{getOtherJobsTotal(other).subtotalCompany | currency: 'EUR'}}" 
            class="fixed-tag"/>    
          <p-tag
          [severity]="getOtherPercent(other) > (case.contract?.profitDesiredPercent ?? 0) ? 'success' : getOtherPercent(other) > (case.contract?.profitMinPercent ?? 0) ? 'warn' : 'danger'"
          value="{{getOtherPercent(other) | number:'1.2-2'}}% beneficio" 
            class="fixed-tag"/>    
          <p-tag 
          [severity]="getOtherPercent(other) > (case.contract?.profitDesiredPercent ?? 0) ? 'success' : getOtherPercent(other) > (case.contract?.profitMinPercent ?? 0) ? 'warn' : 'danger'"
          value="{{getOther(other) | currency: 'EUR'}} beneficio" 
            class="fixed-tag"/>
        </div>
      </div>
    </ng-template>
    <p-card styleClass="p-card-content-no-padding p-card-body-pt-0">
      <ng-template pTemplate="header">
        <div class="p-card-title flex gap-2">
          <div class="flex-grow-1">
            Trabajos a la compañia
              
          </div>   
          <div class="flex gap-2 justify-content-end">
              <p-button size="small" label="Importar presupuesto" icon="pi pi-plus" (click)="importTransactionLines('COMPANY', null, null, null)" *ngIf="allowWrite"/>
              <p-button size="small" label="Añadir trabajo" icon="pi pi-plus" (click)="editJob('COMPANY', null, null, null, null)" *ngIf="allowWrite" />
            </div>        
        </div>
      </ng-template>
      <div>   
          
        <p-table [value]="other.companyJobs">

          <ng-template pTemplate="header">
            <tr>
              <th width="80">Fecha</th>
              <th>Descripción</th>
              <th>Revisado</th>
              <th>Facturable</th>
              <th>Destinatario</th>
              <th>Factura</th>
              <th style="text-align: right;">Cantidad</th>
              <th style="text-align: right;">Precio</th>
              <th style="text-align: right;">SubTotal</th>
              <th style="text-align: right;">Impuestos</th>
              <th style="text-align: right;">Total</th>
              <th width="120"></th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-job>
            <tr>              
              <td>{{ job.date | date: 'dd/MM/yyyy' }}</td>
              <td>
                <div *ngIf="job.rateLine">{{ job.rateLine?.code }} - {{ job.rateLine?.description }}</div>
                <div *ngIf="job.rateLine==null&&job.rateLineCode">{{ job.rateLineCode }} - {{ job.rateLineDescription }}</div>
                    
                <div *ngIf="job.description">{{ job.description }}</div>
              </td>
              <td>
                <i class="pi" [ngClass]="{
                              'text-green-500 pi-check-circle': job.isReview,
                              'text-red-500 pi-times-circle': !job.isReview
                          }"></i>
              </td>
              <td>
                <i class="pi" [ngClass]="{
                              'text-green-500 pi-check-circle': job.isBillable,
                              'text-red-500 pi-times-circle': !job.isBillable
                          }"></i>
              </td>
              <td>
                {{ job.target == 'Client' ? 'Asegurado' : job.target == 'Company' ? 'Compañía' : '' }}
              </td>
              <td>
                <a *ngIf="job.transactionId"
                  (click)="goToTransaction(job.transactionId, job.transaction?.transactionType?.code)">
                  {{ job.transaction?.code + ' - ' + (job.transaction?.date | date:'dd/MM/yy') }}
                </a><br>
                <span *ngIf="job.transactionId" class="p-tag" [style.backgroundColor]="job.transaction?.transactionState?.backgroundColor" [style.foregroundColor]="job.transaction?.transactionState?.foregroundColor">
                  <span class="p-tag-label">{{job.transaction?.transactionState?.name}}</span>
                </span>
                <br>
                <a *ngIf="job.transactionId && job.transaction?.relatedTransactionId"
                  (click)="goToTransaction(job.transactionId, job.transaction?.relatedTransaction?.code)">
                  {{ job.transaction?.relatedTransaction?.code + ' - ' + (job.transaction?.relatedTransaction?.date | date:'dd/MM/yy') }}
                </a><br>
                <span *ngIf="job.transactionId && job.transaction?.relatedTransactionId" class="p-tag" [style.backgroundColor]="job.transaction?.relatedTransaction?.transactionState?.backgroundColor" [style.foregroundColor]="job.transaction?.relatedTransaction?.transactionState?.foregroundColor">
                  <span class="p-tag-label">{{job.transaction?.relatedTransaction?.transactionState?.name}}</span>
                </span>
              </td>
              <td style="text-align: right;">{{ job.quantity }}</td>
              <td style="text-align: right;">
                {{ job.unitPrice | currency: 'EUR' }} 
                <span *ngIf="job.jobCompanyDiscountPercent">({{ job.jobCompanyDiscountPercent }}%)</span>
                <small *ngIf="job.jobGuardCompanyIncrementPercent"><br>(Guardia: {{ job.jobGuardCompanyIncrementPercent }}%)</small>
              </td>
              <td style="text-align: right;">{{job.subtota | currency: 'EUR' }}</td>
              <td style="text-align: right;">
                {{ '(' + (job.taxPercent != null ? job.taxPercent : 0) + '%) ' }}
                {{ job.taxAmount | currency: 'EUR' }}
              </td>
              <td style="text-align: right;">{{ job.total | currency: 'EUR' }}</td>
              <td>
                <div class="flex gap-2 justify-content-end" style="width: 100%;">
                  <p-button *ngIf="allowDelete && job.transactionId == null && !job.isBillable && job.workerBillableItemLineId == null" (click)="deleteJob(job)"
                    [rounded]="true" [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                  <p-button *ngIf="allowWrite" (click)="editJob('COMPANY', job, null, job.workerId, job.providerId)" [rounded]="true"
                                  [text]="false"><i class="pi pi-pencil"></i></p-button>
                </div>
              </td>
            </tr>
            <tr *ngIf="getFilteredJobsOthers(other, true).length ==0">
              <td [attr.colspan]="12">
                No se han encontrado trabajos registrados
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="footer">
            <tr>
              <td colspan="8" class="text-right">Base Imponible</td>
              <td style="text-align: right;">{{getOtherJobsTotal(other).subtotalCompany | currency: 'EUR'}}</td>
              <td class="text-right">Total</td>
              <td style="text-align: right;">{{getOtherJobsTotal(other).totalCompany | currency: 'EUR'}}</td>
              <td colspan="1"></td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="12">No se han encontrado trabajos registrados</td>
            </tr>
          </ng-template>
        </p-table>

      </div>
    </p-card>
  </p-accordionTab>  



  <p-messages severity="info" *ngIf="groupedWorkers.length == 0" class="no-margin-messages">
    <ng-template pTemplate>
      El expediente no tiene ningún trabajo registrado
    </ng-template>
  </p-messages>
</p-accordion>

<p-dialog header="Seleccione una plantilla de baremo" [(visible)]="displayRateTemplateModal" [modal]="true"
  [closable]="false" [style]="{width: '400px'}">
  <div class="input-field">
    <label for="date">Plantilla</label>
    <p-dropdown [options]="ratesTemplates" [(ngModel)]="templateId" optionLabel="name" optionValue="id"
      appendTo="body"></p-dropdown>
  </div>

  <ng-template pTemplate="footer">
    <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary"
      (click)="hideRateTemplateModal()"></button>
    <button pButton label="Importar" icon="pi pi-check" (click)="saveRateTemplate()"></button>
  </ng-template>
</p-dialog>

<p-overlayPanel #opService appendTo="body" [dismissable]="false" [showCloseIcon]="true">
  <button type="button" class="popover-close-button" (click)="opService.hide()" aria-label="Cerrar"><i class="pi pi-times"></i></button>
  <div *ngIf="selectedService!=null && selectedService.dateStart!=null" class="flex flex-column gap-2" style="max-width: 450px;">
    <div>
      <label><b>Inicio intervención:</b></label>
      {{selectedService.dateStart | date: 'dd/MM/yyyy HH:mm'}}
    </div>
    <div>
      <label><b>Fin intervención:</b></label>
      {{selectedService.dateEnd | date: 'dd/MM/yyyy HH:mm'}}
    </div>
    <div>
      <label><b>Trabajos realizados:</b></label>
      {{selectedService.realizedTasksDescription}}
    </div>
    <div  class="text-danger" *ngIf="selectedService.economicNotes!=null && selectedService.economicNotes!=''">
      <label><b>Información económica/privada:</b></label>
      {{selectedService.economicNotes}}
    </div>
    <div>
      <label><b>Trabajos pendientes:</b></label>
      {{selectedService.pendingTasksDescription}}
    </div>
    <div *ngIf="images.length>0" class="p-card-title mt-2">
      Archivos
    </div>
    <div class="image-container  mt-2">
      <div *ngFor="let image of images" class="col-1 imagen-item">        
          <img [d-img-lazy]="imagesUrl + image.fileId + '/thumbnail'" width="100" height="100"
          [pTooltip]="getTooltipImage(image)"
          tooltipPosition="right"
          [escape]="false"
          [style.cursor]="'pointer'"
          (click)="downloadFile(image.fileId)"> 
      </div>
    </div>
  </div>
  <div *ngIf="selectedService?.dateStart==null">
    Visita no iniciada
  </div>
</p-overlayPanel>